import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import NumberFormat from 'react-number-format';
import * as tonkhoAction from './actions'
import * as tonKhoConstant from './constants'
import { storedb } from '../client/storedb'

class TonKhoEdit extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    tonKhoUpdateRequest: PropTypes.func,
    tonKhoDetailRequest: PropTypes.func,
    khoListRequest: PropTypes.func,
    tonKhoEdit: PropTypes.shape({
      item: PropTypes.object,
      listDvt: PropTypes.array,
      listNganhHang: PropTypes.array,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {},
      SoLuongSauKiem: 0,
      formError: {},
      formValid: false,
      StoreId: dbContext.getStoreId(),
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleSoLuongChange = (name, data) => {
    let {formError} = this.state;
    formError.SoLuongSauKiem =""
    this.setState({SoLuongSauKiem: data.floatValue,formError })
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { tonKhoDetailRequest } = this.props
    let tonKhoId = this.getParam("ton");
    var requestData = {
      TonKhoId: tonKhoId || 0,
      StoreId: this.state.StoreId
    }
    return tonKhoDetailRequest(requestData);
  }
  UpdateTonKho = () => {
    let {formError, formValid} = this.state;
    if (this.state.SoLuongSauKiem==null) {
      formError.SoLuongSauKiem = 'Bạn chưa nhập số lượng cần kiểm kho';
    }
    formValid = true;
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state;
      let requestData = {
        StoreId: this.state.StoreId,
        TonKhoId: item.TonKhoId,
        SoLuong: this.state.SoLuongSauKiem
      };
      this.props.tonKhoUpdateRequest(requestData);
    }
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.UpdateTonKho()
    }
  }
  BackToListproducts = (item, e) => {
    e.preventDefault();
    this.props.history.push('/tonkho');
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.tonKhoEdit.type == tonKhoConstant.TONKHO_DETAIL_SUCCESS) {
      let { item } = nextProps.tonKhoEdit;
      if (item.TonKhoId && item.TonKhoId > 0) {
        this.setState({
          item: item
        });
      }
    } else if (nextProps.tonKhoEdit.type == tonKhoConstant.TONKHO_UPDATE_SUCCESS) {
      this.props.history.push("/tonkho");
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      handleSubmit,
      tonKhoEdit: {
        isRequesting,
        errors,
        messages,
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form className="row">
            <FormGroup className="col-sm-6">
              <Label >Mã sản phẩm</Label>
              <Input type="text" name="Sku" placeholder="Mã sản phẩm" disabled value={item.Sku || ''}/>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Tên sản phẩm</Label>
              <Input type="text" name="Ten" placeholder="Tên sản phẩm" disabled value={item.TenHang || ''}/>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label>Số lượng cũ</Label>
              <NumberFormat
                disabled
                name={"SoLuong"}
                value={item.SoLuong}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Số lượng sau kiểm kho</Label>
              <NumberFormat
                name={"SoLuongSauKiem"}
                value={this.state.SoLuongSauKiem}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleSoLuongChange.bind(this, "SoLuongSauKiem")}
                className={"form-control order-input-price price"} 
                onKeyDown={e => this.keyPress(e)}/>
                <em className="error invalid-feedback">{formError.SoLuongSauKiem}</em>
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <Button size="md" color="success" className="mr-1" onClick={this.BackToListproducts.bind(this, {})}><i className="fa fa-list"></i> Danh sách</Button>
            <Button size="md" color="primary" className="mr-1" onClick={handleSubmit(this.UpdateTonKho)}><i className="fa fa-save"></i> Lưu</Button>
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  tonKhoEdit: state.tonKhoEdit,
})
const connected = connect(mapStateToProps, {
  tonKhoDetailRequest: tonkhoAction.tonKhoDetailRequest,
  tonKhoUpdateRequest: tonkhoAction.tonKhoUpdateRequest,
  khoListRequest: tonkhoAction.khoListRequest,
})(TonKhoEdit)

const formed = reduxForm({
  form: 'tonKhoEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/TonKho/TonKhoEdit.js